/* eslint-disable */

import { COLOR_MAP } from './AssetDonutChart'

const AssetAllocationTable = ({ assets, hideTitle = false, hideCard = false }) => {
  // Format currency in Indian number system
  const formatIndianCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0,
    }).format(amount)
  }

  // Format percentage to 2 decimal places
  const formatPercentage = (percentage) => {
    return parseFloat(percentage).toFixed(2)
  }

  // Calculate total
  const totalAmount = assets?.reduce((sum, asset) => sum + asset.amount, 0)
  const totalPercentage = assets?.reduce((sum, asset) => sum + asset.percentage, 0)

  const content = (
    <>
      {!hideTitle && (
        <div className='px-4 sm:px-6 py-3 sm:py-4 border-b border-gray-200 dark:border-fb-border'>
          <h2 className='text-base sm:text-lg dark:text-fb-strong'>Asset Allocation</h2>
        </div>
      )}

      <div className='overflow-x-auto'>
        <div className='rounded-lg border border-gray-200 overflow-hidden dark:border-fb-border'>
          <table className='w-full'>
            <thead>
              <tr className='bg-gray-50 border-b border-gray-200 dark:bg-fb-muted dark:border-fb-border'>
                <th className='px-4 sm:px-6 py-3 text-left text-xs sm:text-sm text-gray-600 dark:text-fb-secondary'>
                  Asset Category
                </th>
                <th className='px-4 sm:px-6 py-3 text-right text-xs sm:text-sm text-gray-600 dark:text-fb-secondary'>
                  Amount
                </th>
                <th className='px-4 sm:px-6 py-3 text-right text-xs sm:text-sm text-gray-600 whitespace-nowrap dark:text-fb-secondary'>
                  Share (%)
                </th>
              </tr>
            </thead>
            <tbody>
              {assets?.map((asset, index) => (
                <tr
                  key={asset.category}
                  className={`border-b border-gray-100 dark:border-fb-border ${
                    index % 2 === 0
                      ? 'bg-white dark:bg-fb-surface'
                      : 'bg-gray-50/50 dark:bg-fb-raised'
                  }`}
                >
                  <td className='px-4 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm text-gray-900 dark:text-fb-text'>
                    <div className='flex items-center gap-2'>
                      <div
                        className='w-3 h-3 rounded-full flex-shrink-0'
                        style={{ backgroundColor: COLOR_MAP[asset.category] || '#6B7280' }}
                      />
                      <span>{asset.category}</span>
                    </div>
                  </td>
                  <td className='px-4 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm text-gray-900 text-right tabular-nums dark:text-fb-text'>
                    {formatIndianCurrency(asset.amount)}
                  </td>
                  <td className='px-4 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm text-gray-900 text-right tabular-nums dark:text-fb-text'>
                    {formatPercentage(asset.percentage)}%
                  </td>
                </tr>
              ))}

              {/* Total Row */}
              <tr className='bg-teal-50 border-t-2 border-teal-200 dark:bg-fb-accentSoft dark:border-fb-accent'>
                <td className='px-4 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm text-gray-900 dark:text-fb-strong'>
                  Total
                </td>
                <td className='px-4 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm text-gray-900 text-right tabular-nums dark:text-fb-strong'>
                  {formatIndianCurrency(totalAmount)}
                </td>
                <td className='px-4 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm text-teal-700 text-right tabular-nums dark:text-fb-accentText'>
                  {formatPercentage(totalPercentage)}%
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  )

  if (hideCard) {
    return content
  }

  return (
    <div className='bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden dark:bg-fb-surface dark:border-fb-border'>
      {content}
    </div>
  )
}

export default AssetAllocationTable
